import React, { useEffect, useRef, useState, useContext } from 'react'
import { ContextSequences } from '../context'
import drawImageProp from '../helpers/drawImageProp'
import { loadImage } from '../helpers/loadSequence'
import { tabletP } from '../utils/bp'

const JpegSequence = ({ className, folder = '01', scrollRatio, frameCount }) => {

	// Detect mobile
	const [isMobile, setIsMobile] = useState(false)
	useEffect(() => {
		setIsMobile(localStorage.getItem('is-touch') === 'true')
	}, [])

	// Get sequences
	const [quality, setQuality] = useState(null) // null, 'sd' or 'hd'
	const [sequences, setSequences] = useContext(ContextSequences)
	const [sizes, setSizes] = useState({})
	useEffect(() => {
		const sdFolder = sequences[`sd${folder}`]
		const hdFolder = sequences[`hd${folder}`]
		if (hdFolder.length > 0 && quality !== 'hd') {
			setQuality('hd')
		}
		else if (sdFolder.length > 0 && hdFolder.length === 0 && quality === null) {
			setQuality('sd')
		}
	}, [sequences])

	const [isVisible, setIsVisible] = useState(true)
	const canvasEl = useRef(null)
	const context = useRef(null)

	useEffect(() => {
		context.current = canvasEl.current.getContext('2d')
	}, [])

	useEffect(() => {
		const handleResize = () => {
			setSizes({
				width: window.innerWidth,
				height: window.innerHeight
			})
		}
		handleResize()
		window.addEventListener('resize', handleResize)
		return () => {
			window.removeEventListener('resize', handleResize)
		}
	}, [])

	useEffect(() => {
		if (canvasEl.current == null || sizes === null) return
		canvasEl.current.width = sizes.width
		canvasEl.current.height = sizes.height
	}, [sizes])

	const updateImage = (index, forceHighQuality = false) => {
		if (quality === null) return

		let img = null

		const currentFolder = sequences[`${quality}${folder}`]
		img = currentFolder[index]

		if (img) {
			drawImageProp(context.current, img, 0, 0, sizes.width, sizes.height, 0.5, 0.5)
		}
	}

	const isScrolling = useRef(null)
	useEffect(() => {
		if(scrollRatio === 1 && isVisible === true) {
			setIsVisible(false)
		} else if (isVisible === false && scrollRatio < 1) {
			setIsVisible(true)
		}
		const frameIndex = Math.min(
			frameCount - 1,
			Math.ceil(scrollRatio * frameCount)
		)
		requestAnimationFrame(() => updateImage(frameIndex + 1))
	}, [scrollRatio, sequences])

	return (
		<div
			className={`JpegSequence ${className}`}
			style={{ backgroundImage: `url(/sequences/${folder}/${isMobile ? 'fallback-mobile' : 'fallback'}.jpg)` }}
		>
			<canvas className={`JpegSequence__Canvas ${isVisible ? 'isVisible' : ''}`} ref={canvasEl} />
		</div>
	)
}

export default JpegSequence